// CCR view of an organization's Ask Reggie usage this month, read from the
// rhinoanalyst service (the counters live there, not in rhinoapi).
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getOrganizationUsage, isRhinoAnalystConfigured } from '../services/RhinoAnalystService';

const RhinoAnalystOrgUsage = ({ organizationId }) => {
  const [usage, setUsage] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!organizationId || !isRhinoAnalystConfigured()) return undefined;
    const controller = new AbortController();
    getOrganizationUsage(organizationId, { signal: controller.signal })
      .then((data) => setUsage(data))
      .catch((err) => { if (err.name !== 'AbortError') setFailed(true); });
    return () => controller.abort();
  }, [organizationId]);

  if (!organizationId || !isRhinoAnalystConfigured()) return null;
  if (failed) return <div className="u-text-small u-text-muted">Usage is unavailable right now.</div>;
  if (!usage) return null;
  const { org, limit, month } = usage;
  return (
    <div className="u-text-small u-text-muted" data-cypress="rhinoanalystOrgUsage">
      {month}: {org.turns} of {limit} questions used &middot; {org.toolCalls} data lookups &middot; {org.inputTokens + org.outputTokens} tokens
      {org.errors ? ` · ${org.errors} failed` : ''}
    </div>
  );
};

RhinoAnalystOrgUsage.propTypes = { organizationId: PropTypes.number };
RhinoAnalystOrgUsage.defaultProps = { organizationId: null };

export default RhinoAnalystOrgUsage;
